export const prodSearchPath = "-1,2000,2010"
export const stagingSearchPath = "-1,7267,7273"
